import React, { useState } from 'react';
import TimePicker from 'react-time-picker';
import {ReactComponent as DropdownIcon} from '../components/svgs/dropdownIcon.svg';

const DropdownTimePicker = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);

  const handleInputClick = () => {
    setIsOpen(!isOpen);
  };

  const handleTimeChange = (time) => {
    setSelectedTime(time);
    setIsOpen(false);
  };

  return (
    <div className="dropdown-timepicker">
        <label htmlFor=""> Pickup Time
            <input
                type="text"
                placeholder="00 : 00"
                value={selectedTime || ''}
                onClick={handleInputClick}
                readOnly
                style={{ width: '305px' }}
                className='mt-2'
            />
            <DropdownIcon className="dropdown-icon mt-4" onClick={handleInputClick} />
            {isOpen && (
                <div className="timepicker-container">
                <TimePicker
                    value={selectedTime}
                    onChange={handleTimeChange}
                    disableClock
                />
                </div>
            )}
        </label>
    </div>
  );
};

export default DropdownTimePicker;
